<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="dedication" id="ded">
<p class="dedf"><a class="page" id="pv"></a><i>To my parents, for your love.</i></p>
<p class="ded"><i>And to Qin, for your steadfast support.</i></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// uma-HUANG-0007.vue?6cfd2370